import React from "react";
import logo from "../../../assets/img/logo/logo.png";
import "../../../assets/scss/components/app-loader.scss";

class SpinnerComponent extends React.Component {
  state = { visible: true };
  startedAt = Date.now();
  timeoutId = null;

  componentDidMount() {
    this.startedAt = Date.now();
    // Si no se provee `show`, mantener visible por defecto (importante cuando se usa standalone)
    const showProp = this.props.show;
    const visible = typeof showProp === "undefined" ? true : !!showProp;
    this.setState({ visible });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show) {
      if (this.props.show) {
        // se vuelve a mostrar
        clearTimeout(this.timeoutId);
        this.startedAt = Date.now();
        this.setState({ visible: true });
      } else {
        // se va a ocultar, pero respetando mínimo de ms
        const minMs = Number(this.props.minMs ?? 700);
        const elapsed = Date.now() - this.startedAt;
        const remaining = Math.max(0, minMs - elapsed);

        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => {
          this.setState({ visible: false });
        }, remaining);
      }
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  render() {
    const { message = "Loading...", fullscreen = true } = this.props;
    if (!this.state.visible) return null;

    return (
      <div className={`fallback-spinner ${fullscreen ? "is-fullscreen" : ""}`}>
        <div className="fallback-content modern">
          <img className="fallback-logo" src={logo} alt="logo" />

          <div className="loading-dots" aria-label="Cargando" role="status">
            <div className="dot dot-1"></div>
            <div className="dot dot-2"></div>
            <div className="dot dot-3"></div>
          </div>

          {message ? <div className="fallback-text">{message}</div> : null}
        </div>
      </div>
    );
  }
}

export default SpinnerComponent;
